/**
 * @file: 逻辑移动后，需要更新的组件列表
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../../cubeTree/index';

function logicUpdateList(moveTask: MoveTask, skip: CubeId[]): CubeId[] {
    let result: Set<CubeId> = new Set();
    let skipList: Set<CubeId> = new Set(skip);

    moveTask.logic.forEach((logicTask: LogicMoveTask): void => {
        if (CubeTree.isShelf(logicTask.from.moveTarget)) {
            return;
        }

        let itsShelf: CubeId = CubeTree.findCubeShelf(logicTask.from.moveTarget);

        if (skipList.has(itsShelf)) {
            return;
        }

        !skipList.has(logicTask.to.parent) && result.add(logicTask.to.parent);
        !skipList.has(logicTask.from.parent) && result.add(logicTask.from.parent);
    });

    return Array.from(result);
}

export {
    logicUpdateList
};
